import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const AlbertaIcon = (props: BaseProvinceIconProps) => {
  return (
    <path
      id="AB"
      {...props}
      d="M69.9,177.8c10.6,1.8,21,3.6,31.6,5.5c0.6,0.1,0.9,0.6,0.9,1.2c-3.1,26.2-6.1,52.2-9.1,78.4
        c-0.1,0.4-0.4,0.7-0.8,0.7c-2.4-0.5-7.4-1.8-8.8-2.1c-0.2-0.1-0.4-0.2-0.6-0.4c-1.9-3.2-16.9-29.1-23.3-40.5
        c-0.3-0.5-0.4-1.4-0.3-1.9c2.7-11.9,8.2-35.1,9.4-39.9C69,178.1,69.4,177.8,69.9,177.8L69.9,177.8z"
    />
  );
};
